/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarcode: {
  name: 'barcode';
  data: string;
} = {
  name: 'barcode',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a1 1 0 0 0-2 0v16a1 1 0 1 0 2 0V4Zm3 0a1 1 0 0 0-2 0v12a1 1 0 1 0 2 0V4Zm15 0a1 1 0 1 0-2 0v16a1 1 0 1 0 2 0V4ZM11 3a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Zm4 1a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0V4Zm3-1a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
